import React from 'react';
import Modal from '@/components/ui/Modal';

type VideoPreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  returnFocusRef?: React.RefObject<HTMLElement | null>;
  videoUrl?: string;
};

const VideoPreviewModal = ({ isOpen, onClose, returnFocusRef, videoUrl }: VideoPreviewModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Vista previa en TV"
      size="xl"
      returnFocusRef={returnFocusRef}
    >
      <div className="space-y-4">
        <div className="text-sm text-gray-500">
          Simulación de reproducción en TV. El video ocupa toda la pantalla.
        </div>
        <div className="relative w-full aspect-video rounded-xl overflow-hidden border border-gray-200 bg-black shadow-inner">
          {videoUrl ? (
            <video
              src={videoUrl}
              className="h-full w-full object-cover"
              controls
              playsInline
            />
          ) : (
            <div className="h-full w-full flex items-center justify-center text-xs text-gray-300">
              No hay video seleccionado
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default VideoPreviewModal;
